<div class="app-forecast-not-found">
  <mat-icon>sentiment_dissatisfied</mat-icon>
  <p class="not-found-message">
    <span [innerHtml]="'forecast.notFoundForecastMessage' | translate"></span>
  </p>
</div>
